/** @file Notes a rev the own client just committed over REST; catches up at once while the socket is closed. */
import { kickSync } from './kickSync';
import type { SyncSession } from './liveSession';

/** Raises knownRev to `rev`; with the socket closed no frame will bring the commit, so the sync loop fetches it. */
export function noteOwnRev(session: SyncSession, rev: number): void {
  session.knownRev = Math.max(session.knownRev, rev);
  if (!session.socketOpen) void kickSync(session);
}
